import { createCsvBlob, downloadBlob } from './downloadFile';

export type CsvCellValue = string | number | boolean | null | undefined;

export const escapeCsvValue = (value: CsvCellValue): string => {
  if (value === undefined || value === null) return '';

  const stringValue = String(value);

  if (
    stringValue.includes(',') ||
    stringValue.includes('\n') ||
    stringValue.includes('\r') ||
    stringValue.includes('"')
  ) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

export const buildCsvRow = (...values: CsvCellValue[]): string =>
  values.map(escapeCsvValue).join(',');

export const buildCsvContent = (rows: CsvCellValue[][]): string =>
  rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n');

export { createCsvBlob } from './downloadFile';

export const downloadCsv = (
  data: string | CsvCellValue[][],
  fileName: string,
  options?: { skipAppendTimestamp?: boolean },
): void => {
  const content = typeof data === 'string' ? data : buildCsvContent(data);
  const blob = createCsvBlob(content);
  downloadBlob(blob, fileName, options);
};
